// src/service/warehouse/component/ComponentService.ts
import type { IComponentService } from './IComponentService';
import type { PagedResponse } from '../dto/PagedResponse';
import type { ListParams } from '../http/ListParams';
import type { CreateComponentRequest } from '../dto/CreateComponentRequest';
import type { UpdateComponentRequest } from '../dto/UpdateComponentRequest';
import type { ComponentStockLevelDto } from '../dto/ComponentStockLevel.dto';
import { QueryBuilder } from '../http/QueryBuilder';
import { JsonRequestBody } from '../http/JsonRequestBody';

// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';
import { ComponentDto } from '../dto/Component.dto';
import { ComponentStatus } from '../types';

const BASE = '/api/warehouse/component';

export class ComponentService implements IComponentService {
    async list(params?: ListParams): Promise<PagedResponse<ComponentDto>> {
        return fetchWithAuth(`${BASE}${QueryBuilder.from(params).build()}`, {
            method: 'GET',
        });
    }

    async get(externalId: string): Promise<ComponentDto> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'GET',
        });
    }

    async create(payload: CreateComponentRequest): Promise<ComponentDto> {
        return fetchWithAuth(BASE, {
            method: 'POST',
            ...JsonRequestBody.from(payload),
        });
    }

    async update(
        externalId: string,
        payload: UpdateComponentRequest,
    ): Promise<ComponentDto> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'PATCH',
            ...JsonRequestBody.from(payload),
        });
    }

    async updateStatus(
        externalId: string,
        status: ComponentStatus,
    ): Promise<ComponentDto> {
        return fetchWithAuth(`${BASE}/${externalId}/status`, {
            method: 'PATCH',
            ...JsonRequestBody.from({ status }),
        });
    }

    async getStock(externalId: string): Promise<ComponentStockLevelDto[]> {
        return fetchWithAuth(`${BASE}/${externalId}/stock`, {
            method: 'GET',
        });
    }
}
